module.exports = __webpack_public_path__ + "static/media/main7.08b9439c.jpg";